import { ReactElement } from 'react'
import { ModelFitment } from 'interfaces'
import styled from 'styled-components'

interface VehicleModelsProps {
  model: ModelFitment
}

export const VehicleModels = (props: VehicleModelsProps): ReactElement => {
  const { model } = props
  return (
    <SubRow>
      <Td width="40%">{model.model}</Td>
      <Td width="20%">{model.years}</Td>
      <Td width="40%">{model.totalApps}</Td>
    </SubRow>
  )
}

const SubRow = styled.div`
  background: #ececea;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
interface TdProps {
  clickable?: boolean
  width?: string
}
const Td = styled.div<TdProps>`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: #050505;
  text-decoration: ${(p) => (p.clickable ? 'underline' : 'none')};
  cursor: ${(p) => (p.clickable ? 'pointer' : 'auto')};
  width: ${(p) => p.width};
  padding-top: 16px;
  padding-bottom: 16px;
  padding-left: 24px;
`
